import React from "react";
import Banner from "./Banner";
import { useEffect, useState } from "react";
const LegalDisclaimer = () => {
  const [htmlContent, setHtmlContent] = useState("");
  
    useEffect(() => {
      fetch("/PolicyPage/disclaimer.txt")
        .then((response) => response.text())
        .then((data) => setHtmlContent(data))
        .catch((error) => console.error("Error loading HTML file:", error));
    }, []);
  return (
    // <div className="w-full min-h-screen py-6 md:py-10 px-3 md:px-6 lg:px-8">
    //   <div className="space-y-6 mx-auto w-full max-w-7xl">
    //     <h1 className="font-semibold text-center text-[#0F172A] text-3xl md:text-4xl lg:text-5xl">
    //       Legal Disclaimer
    //     </h1>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //      <span className="text-gray-500 text-lg"> NextEra Research</span>  is SEBI registered as a Research
    //       Entity in terms of SEBI (Research Analyst) Regulations, 2014. SEBI
    //       Research Analyst No: Registration Number: INH000020280. NEXTERA RESEARCH or its associates have not been debarred/suspended by
    //       SEBI or any other regulatory authority for accessing/dealing in the
    //       securities market.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       The information and views in the reports, our website, and all
    //       services (“Research Information”) are believed to be reliable, but we
    //       do not represent or warrant its accuracy or completeness. Investors
    //       and clients are advised to independently evaluate the market
    //       conditions/risks involved before making any trading or investment
    //       decisions.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       The Research Information is not intended to be an exhaustive statement
    //       on the financial instruments, issuers, markets, or developments
    //       referred to therein. Reasonable care has been taken to ensure that the
    //       Research Information is not misleading or untrue at the time of
    //       publication. Any opinions expressed in the Research Information are
    //       subject to change without notice. The analysis contained is based on
    //       numerous assumptions, which may result in materially different
    //       outcomes.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       Information in the specific research reports is for private use only
    //       and should not form the basis of any contract or commitment. It does
    //       not constitute an offer or solicitation to buy or sell any securities.{" "}
    //       <a
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         href="https://nexteraresearch.in/"
    //         className="text-blue-600 underline"
    //       >
    //         Next Era Research
    //       </a>{" "}
    //       is not responsible for errors of fact or opinion. Investment in the
    //       securities market carries risks, and investors should use their own
    //       judgment when making decisions.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       Users have no right to forward or share our reports, calls, SMS, or
    //       any information provided by us, directly or indirectly. Serious legal
    //       action can be taken if this occurs.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       By accessing{" "}
    //       <a
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         href="https://nexteraresearch.in/"
    //         className="text-blue-600 underline"
    //       >
    //         https://nexteraresearch.in/
    //       </a>
    //       , you agree to the terms and conditions mentioned herein. The site may
    //       contain views of individual contributors, which do not necessarily
    //       represent the views of the management. Linked sites are not under our
    //       control, and we are not responsible for their contents or updates.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       All services provided are at the user's own risk, and RUPESH RAJ PROPRIETOR OF NEXT ERA RESEARCH
    //       Mart does not accept any liability for errors, omissions, or failures
    //       in services, including SMS delivery delays due to technical reasons.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       We expressly disclaim any warranties implied by law. By using this
    //       website, you agree to submit any legal disputes to the jurisdiction of
    //       Singapore Township, Dhabli, INDORE.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       All rights reserved. Unauthorized reproduction, copying, or
    //       distribution of the content is prohibited without prior permission
    //       from NextEra Research. We reserve the right to terminate accounts
    //       of those who violate proprietary rights and take legal action where
    //       necessary.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       By filling out forms on this website, you consent to receive calls or
    //       SMS from Next Era Research, even if your number is on the National
    //       'Do Not Disturb' registry. All disputes will be first subject to
    //       mediation, and if necessary, arbitration under Indian Law.
    //     </p>
    //   </div>
    //   <Banner />
    // </div>
    <div className="py-12" dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export default LegalDisclaimer;
